export const GET_BOOKS = 'GET_BOOKS';
export const GET_BOOK_BY_ID = 'GET_BOOK_BY_ID';
export const UPDATE_BOOK = 'UPDATE_BOOK';
export const DELETE_BOOK = 'DELETE_BOOK';
export const CREATE_BOOK = 'CREATE_BOOK';
